import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query';
import {API, CreateBulkDealPayload} from '@chekin/api';
import {QUERY_CACHE_KEYS, Deal} from '@chekin/core';
import {useIsMounted} from '@chekinapp/ui';

type UseCreateBulkDealMutationProps = UseMutationOptions<
  Deal[],
  Error[],
  CreateBulkDealPayload
>;
function useCreateBulkDealMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess,
}: UseCreateBulkDealMutationProps = {}) {
  const queryClient = useQueryClient();
  const isMounted = useIsMounted();

  return useMutation<Deal[], Error[], CreateBulkDealPayload>({
    mutationFn: payload => API.upselling.createBulkDeal({...payload}),
    onSuccess: (...args) => {
      onSuccess?.(...args);
      void queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_KEYS.deals],
        refetchType: 'all',
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_KEYS.paymentsCart],
        refetchType: 'all',
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY_CACHE_KEYS.summary],
      });
    },
    onMutate,
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    onSettled,
  });
}

export {useCreateBulkDealMutation};
